<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                <van-col span="12">
                    <div class="banner-title">设置</div>
                </van-col>
                <van-col span="6">
                <div class="save" @click="updateAuthority">保存</div>
            </van-col>
            </van-row>
        </div>
        <div class="apply-box">
            <div class="apply-title">设置备注</div>
            <div class="apply-value">
                <div>
                    <van-field v-model="remark" maxlength="10"/>
                </div>
                <!--                <input class="a-input" v-model="remark">-->
                <img v-show="remark" @click="remark=''" class="apply-icon" src="@/assets/theme/light/share/09apply/01close.png">
            </div>
            <div class="apply-title">TA可以看</div>
            <div class="apply-value">
                <div>
                    <van-field v-model="privilege" readonly/>
                    <!--                <input class="a-input" v-model="privilege" :disabled="true">-->
                </div>
                <img class="apply-icon" @click="toPrivilege" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
        </div>
    </div>
</template>

<script>
    import {Toast} from 'vant'

    export default {
        name: 'remarkSet',
        data() {
            return {
                theme: 'light',
                user: {},
                applicationInformation: localStorage.hasOwnProperty("applicationInformation") ? localStorage.getItem("applicationInformation") : '我是',
                remark: localStorage.hasOwnProperty('remark') ? localStorage.getItem("remark") : '',
                privilege: '全部',
                statusPrivilege: localStorage.getItem("statusPrivilege"),
                ecgPrivilege: localStorage.getItem("ecgPrivilege"),
                sportPrivilege: localStorage.getItem("sportPrivilege"),
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme
            }
            this.user = JSON.parse(localStorage.getItem("addUser"));
            if (this.statusPrivilege == 1 && this.ecgPrivilege == 1 && this.sportPrivilege == 1) {
                this.privilege = '全部';
            } else {
                debugger
                this.privilege = '';
                if (this.statusPrivilege == 1) {
                    let p = this.privilege == '' ? '身体状态' : '、身体状态';
                    this.privilege += p;
                }
                if (this.sportPrivilege == 1) {
                    let p = this.privilege == '' ? '运动记录' : '、运动记录';
                    this.privilege += p;
                }
                if (this.ecgPrivilege == 1) {
                    let p = this.privilege == '' ? '心脏健康' : '、心脏健康';
                    this.privilege += p;
                }
            }
        },
        methods: {
            back() {
                localStorage.removeItem("applicationInformation");
                localStorage.removeItem("remark");
                this.$router.back();
            },
            applyMembers() {
                this.$api.share.applyMembers({
                    sharerId: this.user.userId,
                    statusPrivilege: this.statusPrivilege,
                    sportPrivilege: this.sportPrivilege,
                    ecgPrivilege: this.ecgPrivilege,
                    remark: this.remark,
                    applicationInformation: this.applicationInformation
                }).then(res => {
                    localStorage.setItem("statusPrivilege", '1');
                    localStorage.setItem("ecgPrivilege", '1');
                    localStorage.setItem("sportPrivilege", '1');
                    localStorage.removeItem("applicationInformation");
                    localStorage.removeItem("remark");
                    Toast({message: '发送成功！'});
                    // 返回首页
                    this.$router.push({
                        name: 'shareHome',
                        query: {
                            theme: this.theme
                        }
                    })
                })
            },
            toPrivilege() {
                localStorage.setItem("applicationInformation", this.applicationInformation);
                localStorage.setItem("remark", this.remark);
                this.$router.push({
                    name: 'privilegeLight',
                    params: {
                        type: 'update'
                    },
                    query: {
                        theme: this.theme
                    }
                })
            },
            updateAuthority() {
                this.$api.share.updateAuthority({
                    sharerId: this.user.userId,
                    statusPrivilege: this.statusPrivilege,
                    ecgPrivilege: this.ecgPrivilege,
                    sportPrivilege: this.sportPrivilege,
                    remark: this.remark
                }).then(res => {
                    this.back();
                })
            }
        }
    }
</script>

<style scoped>

    .apply-title {
        font-size: 13px;
        color: rgba(0,0,0,0.5);
        margin-top: 20px;
        margin-left: 25px;
        margin-bottom: 12px;
    }

    .apply-value {
        width: 345px;
        height: 56px;
        margin: 0 auto;
        position: relative;
    }

    /deep/ input {
        background-color: transparent;
        color: var(--text-color-1);
        font-size: 15px;
        caret-color: #00BD9B;
        border: none;
        line-height: 36px;
    }

    /deep/ input::-webkit-input-placeholder {
        color: var(--text-color-1);
        opacity: 0.5;
    }

    /deep/ input::-moz-placeholder {
        color: var(--text-color-1);
        opacity: 0.5;
    }

    /deep/ input:-moz-placeholder {
        color: var(--text-color-1);
        opacity: 0.5;
    }

    /deep/ input::-ms-input-placeholder {
        color: var(--text-color-1);
        opacity: 0.5;
    }

    .apply-icon {
        position: absolute;
        width: 22px;
        height: 22px;
        top: 17px;
        right: 12px;
    }

    /deep/ .van-cell {
        background-color: var(--bg-color-2) !important;
        border-radius: 10px;
        height: 56px;
    }

    .save {
        color: #00BD9B;
        font-size: 14px;
        float: right;
        margin-top: 10px;
        margin-right: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/views/shareLight/20remarkSet.vue